// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  villageId: __t.u64().name("village_id"),
  spot: __t.u8(),
  x: __t.f32(),
  y: __t.f32(),
  pose: __t.u8(),
  movedBy: __t.identity().name("moved_by"),
  at: __t.timestamp(),
});
